export default __webpack_public_path__ + "static/media/sticker-of.24175bb9.png";